import React from 'react';
import { Badge } from './ui/badge';
import { portfolioData } from '../mock';

const Skills = () => {
  const { skills } = portfolioData;

  const categories = {
    framework: { label: 'Frameworks', color: 'cyan' },
    language: { label: 'Languages', color: 'blue' },
    backend: { label: 'Backend & Cloud', color: 'green' },
    integration: { label: 'Integrations', color: 'purple' },
    database: { label: 'Database', color: 'orange' },
    tool: { label: 'Tools', color: 'pink' }
  };

  const groupedSkills = Object.keys(categories).reduce((acc, category) => {
    acc[category] = skills.filter(skill => skill.category === category);
    return acc;
  }, {});

  const getColorClasses = (color) => {
    const colors = {
      cyan: 'bg-cyan-400/10 text-cyan-400 border-cyan-400/30 hover:bg-cyan-400/20',
      blue: 'bg-blue-400/10 text-blue-400 border-blue-400/30 hover:bg-blue-400/20',
      green: 'bg-green-400/10 text-green-400 border-green-400/30 hover:bg-green-400/20',
      purple: 'bg-purple-400/10 text-purple-400 border-purple-400/30 hover:bg-purple-400/20',
      orange: 'bg-orange-400/10 text-orange-400 border-orange-400/30 hover:bg-orange-400/20',
      pink: 'bg-pink-400/10 text-pink-400 border-pink-400/30 hover:bg-pink-400/20'
    };
    return colors[color] || colors.cyan;
  };

  return (
    <section id="skills" className="py-16 sm:py-24 bg-slate-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              Technical Skills
            </h2>
            <p className="text-gray-400 text-base sm:text-lg">Technologies I work with</p>
          </div>

          {/* Skills Grid */}
          <div className="space-y-8 sm:space-y-10">
            {Object.entries(groupedSkills).map(([category, categorySkills]) => (
              categorySkills.length > 0 && (
                <div key={category}>
                  <h3 className="text-lg sm:text-xl font-semibold text-white mb-4">
                    {categories[category].label}
                  </h3>
                  <div className="flex flex-wrap gap-3">
                    {categorySkills.map((skill, index) => (
                      <Badge
                        key={index}
                        variant="outline"
                        className={`px-4 py-2 text-sm sm:text-base font-medium border transition-all duration-300 hover:scale-105 ${
                          getColorClasses(categories[category].color)
                        }`}
                      >
                        {skill.name}
                      </Badge>
                    ))}
                  </div>
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;